/* eslint-disable import/prefer-default-export */
import type {
  TenantInfo,
  UserInfo,
  OnboardingProgress,
  NotificationInfo
} from '@src/endpoints/services/commonHdr.service'
import { Organizations, SingleAccounts, SnapshotStateEnum } from './models'

export interface Tenant extends TenantInfo {
  alertSettings?: NotificationInfo[]
}
export interface AccountStats {
  [key: string]: string | number
}
export interface AccountStatsDict {
  [key: string]: AccountStats
}

export interface ProgressList {
  [key: string]: OnboardingProgress
}
export interface User extends UserInfo {}

export const defaultState = {
  singleAccounts: {
    entities: {},
    accountUIDs: [],
    accountIds: []
  } as SingleAccounts,
  organizations: {
    entities: {},
    organizationIds: [],
    organizationUIDs: [],
    subOrganizationsUIDs: [],
    subOrganizationsIds: [],
    accountIds: [],
    accountUIDs: []
  } as Organizations,
  tenant: {
    account_info: [],
    organization_info: [],
    alertSettings: [] as NotificationInfo[]
  } as Tenant,
  user: null as User,
  isPending: true,
  errors: null as any,
  isPendingProgress: false,
  accountRegisterPending: false,
  isLoggedIn: false,
  isLoggedOut: false,
  accountStats: {} as AccountStatsDict,
  progressList: {} as any,
  snapshotState: {
    lastErrorTimestamp: null,
    snapshotState: SnapshotStateEnum.Normal,
    isRefreshing: false,
    lastRefreshTriggered: {},
    isRefreshTriggered: false
  } as any,
  sourcesImprovementsFlag: false,
  idnAPIUrl: ''
}

export type AuthState = typeof defaultState
